import React, { FC, ReactNode } from 'react'
import { SidebarUI } from './SidebarUi'

interface Props {
  pageProps: {
    orderSummary: ReactNode
  }
}

export const LayoutWithHeader: FC<Props> = ({ children }) => {
  return (
    <div className={`h-full relative gradient-background`}>
      <div className="relative z-20 text-base overflow-y-auto">
        <main id="checkout-layout-main" className="min-h-screen lg:flex">
          {children}
        </main>
        <div className="max-w-content-xl mx-content-margin-mobile sm:mx-content-margin-desktop 2xl:mx-auto">
          <SidebarUI menuCategories={[]} />
        </div>
      </div>
    </div>
  )
}
